
import {BaseComponent} from "../BaseComponent";
import {Component, Prop, Ref} from "vue-property-decorator";
import {InformationModalData} from "@/core/components/InformationModal/models/information-modal-data";
import {BModal} from "bootstrap-vue";

@Component({
    components: {
        'b-modal': BModal
    }
})
export default class InformationModal extends BaseComponent {

    // Component references:
    @Ref("modal") modal!: BModal;

    // Component properties:
    @Prop({required: true, type: Object}) data!: InformationModalData;

    public show(): void {
        this.modal.show();
    }

    private onOkButtonClick(cancelCallback: Function): void {
        this.data.AfterFinishCallback?.();
        cancelCallback();
    }
}
